import React, { useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Langs from "../../../app/lang/langs";
import { checkPermission, getUserPreferences, isOwner } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config.js";
import { ShiftCell } from "../../../components/scheduler/cells/shiftCell.js";
import { generateSampleShift } from "../../../components/scheduler/shifts/sampleShiftsSlice";
import { setShowFormPopup } from "../../planning/planningSlice";
import { useDispatch, useSelector } from "react-redux";

const TRANSITION_SMOOTH = "all 0.28s cubic-bezier(0.4, 0, 0.2, 1)";

export default function MobileShiftTemplatesTab({ mobileAddRef }) {
  const dispatch = useDispatch();

  const settings = useSelector((state) => state.settings);
  const userId = useSelector((state) => state.login.userId);
  const sampleShifts = useSelector((state) => state.sampleShifts.list);
  const userRoleId = useSelector((state) => state.login.userRoleId);
  const permissions = useSelector((state) => state.login.permissions);

  const canEditTemplates =
    isOwner(userRoleId) ||
    checkPermission(config.scopes.settings, config.permissionTypes.edit);

  function getOrderedShifts() {
    let shiftsArray = [].concat(sampleShifts).filter((s) => s.id);
    let shiftsUserOrder = getUserPreferences(userId, "SHIFTS_SAMPLES_ORDER");
    if (shiftsUserOrder) {
      shiftsArray = shiftsArray.sort((a, b) => {
        return (
          shiftsUserOrder.indexOf(`${a.id}`) -
          shiftsUserOrder.indexOf(`${b.id}`)
        );
      });
    }
    return shiftsArray;
  }

  const handleEditShift = (shiftData) => {
    if (canEditTemplates && shiftData) {
      dispatch(setShowFormPopup({ type: "SAMPLE_SHIFT", data: shiftData }));
    }
  };

  const handleAddSampleShift = () => {
    let heureDebut = 9,
      heureFin = 17;
    Object.values(settings.settingsList).map((item) => {
      if (item.label === "Heure début de journée")
        heureDebut = item.settingValue;
      if (item.label === "Heure fin de journée") heureFin = item.settingValue;
    });
    dispatch(
      setShowFormPopup({
        type: "ADD_SAMPLE_SHIFT",
        data: generateSampleShift(heureDebut, heureFin),
      })
    );
  };

  useEffect(() => {
    if (mobileAddRef && canEditTemplates) {
      mobileAddRef.current = () => handleAddSampleShift();
      return () => {
        mobileAddRef.current = null;
      };
    }
  }, [mobileAddRef, userRoleId, permissions]);

  const orderedShifts = getOrderedShifts();

  return (
    <Box sx={{ width: "100%", mt: 0, pb: 2, px: 0.5, pt: 1 }}>
      {orderedShifts.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 8,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.9rem",
              color: "rgba(0,0,0,0.35)",
              fontWeight: 500,
            }}
          >
            <Langs str="NO_DATA" />
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {orderedShifts.map((shift, idx) => (
            <Box
              key={shift.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                height: 52,
                bgcolor: "#fff",
                borderRadius: "12px",
                boxShadow:
                  "0 1px 3px rgba(0,0,0,0.06), 0 2px 8px rgba(0,0,0,0.03)",
                px: 1,
                transition: TRANSITION_SMOOTH,
                animation: `fadeSlideIn 0.3s ease ${idx * 30}ms both`,
                "@keyframes fadeSlideIn": {
                  from: {
                    opacity: 0,
                    transform: "translateY(8px)",
                  },
                  to: {
                    opacity: 1,
                    transform: "translateY(0)",
                  },
                },
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  height: 42,
                  position: "relative",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <ShiftCell data={shift} isInteractive={true} />
              </Box>
              {canEditTemplates && (
                <IconButton
                  size="small"
                  onClick={() => handleEditShift(shift)}
                  sx={{
                    flexShrink: 0,
                    width: 40,
                    height: 40,
                    bgcolor: "rgba(255, 144, 21, 0.08)",
                    border: "1px solid rgba(255, 144, 21, 0.18)",
                    borderRadius: "10px",
                    transition: TRANSITION_SMOOTH,
                    "&:active": {
                      bgcolor: "rgba(255, 144, 21, 0.2)",
                      transform: "scale(0.93)",
                    },
                  }}
                >
                  <EditIcon sx={{ fontSize: 18, color: "#FF9015" }} />
                </IconButton>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
